<div class="pd-page" *ngIf="product">

  <!-- BREADCRUMB -->

  <nav class="pd-breadcrumb">

    <a routerLink="/">{{ t('pdHome') }}</a>

    <ng-container *ngIf="product.category?.id">
      <span class="sep">›</span>
      <a [routerLink]="['/category', product.category.id]">{{ categoryLabel }}</a>
    </ng-container>

    <span class="sep">›</span>

    <span class="current">{{ languageService.productName(product) }}</span>

  </nav>


  <div class="pd-layout">

    <!-- ================= MAIN COLUMN ================= -->

    <div class="pd-main">

      <!-- TOP CARD: gallery + info -->

      <section class="pd-card pd-top">

        <!-- GALLERY -->

        <div class="pd-gallery">

          <div class="pd-main-image">

            <span class="pd-ribbon" *ngIf="product.discount">
              -{{ product.discount | bnNumber }}%
            </span>

            <img
              [src]="getImage(selectedImage)"
              [alt]="languageService.productName(product)"
              (error)="onImgError($event)"
            >

          </div>

          <div class="pd-thumbs" *ngIf="images.length > 1">

            <button
              type="button"
              class="pd-thumb"
              *ngFor="let img of images"
              [class.active]="img === selectedImage"
              (click)="selectedImage = img"
            >
              <img [src]="getImage(img)" alt="" (error)="onImgError($event)">
            </button>

          </div>

        </div>


        <!-- INFO -->

        <div class="pd-info">

          <h1>{{ languageService.productName(product) }}</h1>

          <div class="pd-meta" *ngIf="product.brand">
            {{ t('brandLabel') }}:
            <strong class="pd-link-text">{{ product.brand }}</strong>
          </div>

          <div class="pd-meta" *ngIf="product.category?.id">
            {{ t('categoryLabel') }}:
            <a
              class="pd-link-text"
              [routerLink]="['/category', product.category.id]"
            >{{ categoryLabel }}</a>
          </div>


          <!-- PRICE -->

          <div class="pd-deal" *ngIf="product.discount">

            <span class="pd-deal-badge">{{ t('offerBadge') }}</span>

            <span class="pd-deal-off">
              - {{ product.discount | bnNumber }}% {{ t('off') }}
            </span>

          </div>

          <div class="pd-price">
            {{ getFinalPrice(product) | bnNumber:'৳ ' }}
          </div>

          <div class="pd-regular" *ngIf="product.discount">

            {{ t('regularPrice') }}:
            <s>{{ product.price | bnNumber:'৳ ' }}</s>

          </div>

          <div class="pd-saving" *ngIf="savedAmount > 0">
            {{ t('youAreSaving') }} {{ savedAmount | bnNumber:'৳ ' }}
          </div>


          <!-- STOCK -->

          <div
            class="pd-stock"
            [class.out]="product.stock <= 0"
          >
            {{ product.stock > 0 ? t('inStock') : t('outOfStockMark') }}
          </div>


          <!-- HIGHLIGHTS -->

          <div
            class="pd-highlights"
            *ngIf="product.origin || product.quantity || product.weight"
          >

            <span class="pd-hl-title">{{ t('highlights') }}:</span>

            <ul>

              <li *ngIf="product.origin">
                {{ t('countryOfOrigin') }}:
                <strong>{{ languageService.translateOrigin(getOriginName(product.origin)) }}</strong>
              </li>

              <li *ngIf="product.quantity && product.unit">
                {{ t('sizeLabel') }}:
                <strong>
                  {{ product.quantity | bnNumber }}
                  {{ languageService.translateUnit(product.unit) }}
                </strong>
              </li>

              <li *ngIf="product.weight">
                {{ t('weightLabel') }}:
                <strong>{{ product.weight }}</strong>
              </li>

            </ul>

          </div>


          <!-- CART ROW -->

          <div class="pd-cart-row">

            <div class="qty-box" *ngIf="product.stock > 0">

              <button
                type="button"
                class="qty-btn"
                (click)="decreaseQty()"
              >−</button>

              <div class="qty-value">
                <span>{{ quantity | bnNumber }}</span>
                <small>{{ t('inBag') }}</small>
              </div>

              <button
                type="button"
                class="qty-btn"
                (click)="increaseQty()"
              >+</button>

            </div>

            <button
              type="button"
              class="buy-btn"
              [disabled]="product.stock <= 0"
              (click)="buyNow()"
            >
              {{ t('buyNow') }}
            </button>

            <button
              type="button"
              class="cart-go-btn"
              (click)="goToCart()"
            >
              🛒 {{ t('goToCart') }} →
            </button>

          </div>

        </div>

      </section>


      <!-- SPECIFICATION -->

      <section class="pd-card" *ngIf="specRows.length">

        <h2 class="pd-heading">{{ t('specification') }}:</h2>

        <table class="pd-spec">

          <tr *ngFor="let r of specRows">
            <th>{{ r.label }}</th>
            <td>{{ r.value }}</td>
          </tr>

        </table>

      </section>


      <!-- SUMMARY -->

      <section class="pd-card" *ngIf="descriptionText">

        <h2 class="pd-heading">{{ t('summary') }}:</h2>

        <div
          class="pd-desc"
          [class.collapsed]="descriptionIsLong && !showFullDesc"
        >
          {{ descriptionText }}
        </div>

        <div class="pd-more-wrap" *ngIf="descriptionIsLong">

          <button
            type="button"
            class="pd-more-btn"
            (click)="showFullDesc = !showFullDesc"
          >
            {{ showFullDesc ? t('showLess') : t('showMore') }}
          </button>

        </div>

      </section>

    </div>


    <!-- ================= SIDEBAR: RELATED ================= -->

    <aside class="pd-side" *ngIf="related.length">

      <section class="pd-card">

        <h2 class="pd-heading">{{ t('relatedProducts') }}</h2>

        <a
          class="pd-rel"
          *ngFor="let r of related"
          [routerLink]="['/product', r.id]"
        >

          <img
            [src]="getImage(r.imageUrl)"
            alt=""
            loading="lazy"
            (error)="onImgError($event)"
          >

          <div class="pd-rel-info">

            <div class="pd-rel-name">
              {{ languageService.productName(r) }}
            </div>

            <div class="pd-rel-brand" *ngIf="r.brand">{{ r.brand }}</div>

            <div class="pd-rel-price">

              {{ getFinalPrice(r) | bnNumber:'৳ ' }}

              <s *ngIf="r.discount">{{ r.price | bnNumber:'৳ ' }}</s>

            </div>

          </div>

        </a>

      </section>

    </aside>

  </div>

</div>


<!-- NOT FOUND -->

<div class="pd-notfound" *ngIf="notFound">

  <h2>{{ t('productNotFound') }}</h2>

  <a routerLink="/">{{ t('backToHome') }}</a>

</div>
